import { useEffect } from "react";
import { toast } from "sonner";
import { driveStatus, driveRunNow } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

/**
 * On each app launch, if Google Drive is connected, quietly run a backup so the
 * user isn't relying solely on the 02:00 UTC nightly job. Runs at most once per
 * app session (sessionStorage guard), and stays silent on failure — a stale
 * Drive token shouldn't nag on every open. No-op when signed out.
 */
export default function DriveAutoBackup() {
    const { user } = useAuth();
    useEffect(() => {
        if (!user) return undefined;
        try { if (sessionStorage.getItem("lisn.drive.autobackup") === "1") return undefined; } catch { /* ignore */ }
        let alive = true;
        (async () => {
            try {
                const s = await driveStatus();
                if (!alive || !s?.connected) return;
                try { sessionStorage.setItem("lisn.drive.autobackup", "1"); } catch { /* ignore */ }
                const r = await driveRunNow();
                if (alive && r?.uploaded > 0) {
                    toast.success(`Backed up ${r.uploaded} session${r.uploaded === 1 ? "" : "s"} to Drive`);
                }
            } catch (e) {
                // Quiet: a stale/expired Drive token would otherwise nag every launch.
                console.warn("[lisn] auto-backup skipped:", e?.response?.data?.detail || e?.message);
            }
        })();
        return () => { alive = false; };
    }, [user]);
    return null;
}
